import * as firebase from 'firebase/app'
import 'firebase/firestore'
import firebaseConfig from './firebase-config.json'
import { call, put } from 'redux-saga/effects'
import { dbError, setStatistics } from 'actions/firebase'

import { FirebaseError, User } from 'firebase'

firebase.initializeApp(firebaseConfig)
const db = firebase.firestore()

function isFirebaseError(error: any): error is FirebaseError {
  return 'code' in error
}

export function* getStatistics() {
  const document = db.collection('statistics').doc('default')
  try {
    const statisticsDocument = yield call([document, document.get])
    yield put(setStatistics(statisticsDocument.data()))
  } catch (e) {
    if (isFirebaseError(e)) {
      yield put(dbError(e))
    } else {
      throw e
    }
  }
}
